import type { RouteRecordRaw } from 'vue-router'

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/views/layouts/AuthLayout.vue'),
    children: [
      {
        path: '/splash',
        name: 'splash',
        component: () => import('@/views/pages/auth/SplashPage.vue'),
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('@/views/pages/auth/LoginPage.vue'),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/pages/auth/ForgotPasswordPage.vue'),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/change-password',
        name: 'change-password',
        component: () => import('@/views/pages/auth/ChangePasswordPage.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
]
